import { HttpProvider } from "../http/http.provider";
import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IHttpRequestConfig } from "../http/types/http.types";
import { IDashboard, ITopPanel, IBottomPanel } from "./dashboard.interface";
import * as _ from "lodash";

export class DashboardDelegate
{
    constructor(private http: HttpProvider) { }
    /** */
    public getDashboardDelegate(orgId: string, userId: string): Observable<IDashboard>
    {
        const config: IHttpRequestConfig = {
            params: {
                orgId: orgId,
                userId: userId
            }
        };

        return this.http.get(ServiceEndpointConstants.endpoints.DASHBOARD.DASHBOARD, null, config).pipe(
            map((response: any) =>
            {
                return {
                    TopPanel: this.normalizeTopPanel(response.data.dashboard.topPanel),
                    BottomPanel: this.normalizeBottomPanel(response.data.dashboard.bottomPanel)
                } as IDashboard;
            }),
            share());


    }

    /**
     * Employee self-service dashboard (formerly DashboardDelegate.getDashboard
     * in employeeServicelib).
     */
    public getDashboardByEmployeeId(employeeId: string): Observable<IDashboard>
    {
        const config: IHttpRequestConfig = {
            params: {
                EmployeeId: employeeId
            }
        };

        return this.http.get(ServiceEndpointConstants.endpoints.DASHBOARD.DASHBOARD_BY_EMP_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    TopPanel: this.normalizeTopPanel(response.data.dashboard.topPanel),
                    BottomPanel: this.normalizeBottomPanel(response.data.dashboard.bottomPanel)
                } as IDashboard;
            }),
            share());
    }

    private normalizeTopPanel(topPanel: any): ITopPanel[]
    {
        return topPanel.map(top =>
        {
            return {
                key: top.key,
                value: top.value,
                icon: top.icon
            };
        });
    }

    private normalizeBottomPanel(bottomPanel: any): IBottomPanel[]
    {
        return bottomPanel.map((bottom, index) =>
        {
            return {
                Title: bottom.title,
                Description: bottom.description,
                icon: bottom.icon,
                hyperlink: bottom.hyperlink,
                dataobject: bottom.panelData,
                chartType: bottom.chartType,
                chartData: this.loadChartData(bottom),
                canvasId: "canvas" + index
            };
        });
    }

    private loadChartData(bottomPanel: any): any
    {
        var _labels = [];
        var _parameters: number[] = [];
        var _bgcolor = [];
        var o = Math.round, r = Math.random, s = 255;

        _.each(_.split(bottomPanel.panelData.value, '|'), function (val, a)
        {
            _parameters[a] = _.toNumber(_.trim(_.split(val, '-')[1]));
            _labels[a] = (_.trim(_.split(val, '-')[0]));
            var bgval = 'rgba(' + o(r() * 225) + ',' + o(r() * 225) + ',' + o(r() * 225) + ',' + r().toFixed(10) + ')';
            _bgcolor[a] = (bgval);
        });

        return {
            labels: _labels,
            datasets: [
                {
                    data: _parameters,
                    backgroundColor: _bgcolor,
                    borderColor: 'grey',
                    borderWidth: 2
                }
            ]
        };
    }
}